const queryKey = "user-info";

export const userKey = {
  all: () => [queryKey],
} as const;
